/**
 * TavolinoBadge — etichetta mostrata su ogni partita assegnata d'ufficio
 * (risultato casuale automatico allo scadere del termine). Riutilizzata in
 * tutti i punti dove compare una partita: calendario, coppe, scheda squadra, feed.
 *
 * `definitive`: quando la finestra di ricorso/correzione (deadline + 1 decade,
 * assenza inclusa) è scaduta, la scritta diventa "Tavolino definitivo".
 */
export function TavolinoBadge({ idSuffix, className = "", definitive = false }) {
    if (definitive) {
        return (
            <span
                className={`op-label inline-flex items-center gap-1 text-[9px] text-t8f95a3 border border-t8f95a3/50 px-1.5 py-0.5 whitespace-nowrap ${className}`}
                title="Tavolino automatico ormai DEFINITIVO: scaduta la finestra di ricorso/correzione (12 giorni, assenza esclusa)."
                data-testid={idSuffix ? `tavolino-badge-${idSuffix}` : "tavolino-badge"}
            >
                Tavolino definitivo
            </span>
        );
    }
    return (
        <span
            className={`op-label inline-flex items-center gap-1 text-[9px] text-tff7a1a border border-tff7a1a/50 px-1.5 py-0.5 whitespace-nowrap ${className}`}
            title="Risultato assegnato d'ufficio allo scadere del termine (tavolino automatico). Ancora modificabile finché non scade la finestra di ricorso."
            data-testid={idSuffix ? `tavolino-badge-${idSuffix}` : "tavolino-badge"}
        >
            Tavolino automatico
        </span>
    );
}

export default TavolinoBadge;
